export default "__VITE_ASSET__Ci3m6FK3__"